import { DetailAndAllocateForSkillDevelopmentComponent } from "../../../components/SupportSystem/SupportForm/current/DetailAndAllocateForSkillDevelopmentComponent";
import { NavbarSupportSystem } from "../../../components/share/NavbarSupportSystem";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";


export function DetailAndAllowcateForSkillDevelopmentContainer() {
    const titleName = "ระบบการให้เงินช่วยเหลือหรืออุดหนุนกองทุนพัฒนาฝีมือแรงงาน";
    return(
        <div className="page-container bg-landing">
            <NavbarSupportSystem />
            <HeadTitle title={titleName} />
            <DetailAndAllocateForSkillDevelopmentComponent/>
            <Footer />
        </div>   
        // 
    )
    
}